import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "207960a1-ea5d-4d7a-89d0-887b48821611",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "number",
    shuffle: false,
    prefixText: "Lr =",
    suffixText: "dB",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 90.7,
};
